export const toggleModal = (id) => {
    const modal = document.getElementById(`${id}__modal`);
    const noModalError = `Modal '${id}' not found! Please ensure the ID is correct and the modal exists in the DOM when 'toggleModal' is called.`;
    if (!modal)
        throw new Error(noModalError);
    try {
        modal.classList.toggle('hide');
        if (!modal.classList.contains('hide')) {
            document.body.style.position = 'absolute';
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.position = '';
            document.body.style.overflow = '';
        }
    }
    catch (e) {
        console.error(e);
    }
};

//# sourceMappingURL=modal-utils.js.map
